import {
  Animatespin,
  SidenavbarCom,
  SearchbarCom,
  Dashboardevents,
} from "../../components";
import Functions from "./index.function";
import localimgpath from "../../js/localimgpath";
export default function TalentFavouritesEvents() {
  const { formatEventDate, eventsData, isLoading, handleEvents } = Functions();
  return (
    <div className=" sm:h-screen w-screen flex flex-col bg-[#000000]">
      {/* Navbar */}
      <SearchbarCom />
      <div className="grid sm:grid-cols-7 lg:grid-cols-6 xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3">
        {/* Left Sidebar */}
        <div className="sm:col-span-2 lg:col-span-1 xs:z-50">
          <SidenavbarCom />
        </div>

        {/* Center Content (Scrollable) */}
        <div className=" sm:col-span-5 h-[calc(100vh-4rem)]">
          <div className={` w-full xs:px-1 sm:pl-4 lg:pl-5 h-full pt-2 pb-1`}>
            <div className="flex flex-col relative w-full h-full bg-[#1A1A1A] xs:px-2 sm:px-3 lg:px-5 rounded-lg">
              <div className="flex items-center justify-start py-5 sm:py-10">
                <h1 className="text-white xs:text-xs sm:text-sm lg:text-4xl font-onestSemiBold">
                  Favorite Events
                </h1>
              </div>
              <div className="flex-1 overflow-y-auto dashboard-scrollbar xs:pr-1 sm:pr-2">
                {isLoading === true ? (
                  <div className="xs:pt-1 sm:pt-2 lg:pt-3">
                    <Animatespin />
                  </div>
                ) : (
                  <>
                    {eventsData?.events?.length === 0 ? (
                      <p className="text-secondary font-onestLight xs:text-xs sm:text-xs lg:text-sm text-center w-full">
                        Data not available
                      </p>
                    ) : (
                      <div className="xs:gap-y-3 sm:gap-y-4 lg:gap-y-5 xl:gap-y-6 grid xs:grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-5">
                        {eventsData?.events?.map((value, index) => (
                          <div key={index}>
                            <Dashboardevents
                              onClick={() => handleEvents(value?.id)}
                              eventthubmail={`${localimgpath?.eventsThumbnail}/${value?.hero_image}`}
                              eventTitle={value?.event_title}
                              evetDate={formatEventDate(value?.event_date)}
                              eventDis={value?.event_type}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
              <div className="pt-5 sm:pt-10"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
